module.exports = __webpack_public_path__ + "img/widgets.d059a081.svg";